<div class="flex justify-center">
   <img src="../../../assets/img/Ostadvisit-Logo-color.svg" class="absolute w-4/12 opacity-50 mt-24" alt="">
   
</div>
